import React from 'react'
import SwitchBetweenSides from './SwitchBetweenSides'
import TemplateHelper from './TemplateHelper'
import ShortcutHelper from './ShortcutHelper'
import withPopover from '../../../HOCs/withPopover'
import {Button} from 'reactstrap'
import TemplateIcon from '../../../shared/icons/TemplateIcon'
import {ReactComponent as CloseIcon} from '../../../assets/icons/close-icon.svg'
import {useSelectedVariantContext} from '../context/SelectedVariantContext'
import KeyboardIcon from '../../../shared/icons/KeyboardIcon'
import classnames from 'classnames'

const CustomButton = ({isOpen, className, ...rest}) => {
    return (
        <Button
            {...rest}
            className={classnames(className, {
                active: isOpen,
            })}
        />
    )
}

const PopoverIcon = withPopover(CustomButton)

const SwitchBetweenSidesWithHelper = () => {
    const {
        state: {has3DPreview, productCreatedType, openUserGuidePopup},
    } = useSelectedVariantContext()

    return (
        <div className={'MockupEditor__Bottom'}>
            {productCreatedType !== 'regularHasTemplate' && <SwitchBetweenSides />}
            {productCreatedType !== 'regularNoTemplate' && (
                <div
                    className={'ExtraInformation list'}
                    style={{
                        '--gap': '0.5rem',
                    }}
                >
                    <PopoverIcon
                        defaultOpen={openUserGuidePopup}
                        color={'default'}
                        className={'Icon shadow-1'}
                        ContentComponent={({togglePopover}) => {
                            return (
                                <div className={'TemplateHelper__Wrapper'}>
                                    <div className={'d-flex align-items-center justify-content-between mb-4'}>
                                        <p className={'mb-0 font-medium fs-16'}>Design tutorial guideline</p>
                                        <CloseIcon onClick={togglePopover} role={'button'} />
                                    </div>
                                    <div className="TemplateHelper__Divider" />
                                    <TemplateHelper
                                        has3DPreview={has3DPreview}
                                        productCreatedType={productCreatedType}
                                    />
                                </div>
                            )
                        }}
                        placement={'top'}
                        trigger={'click'}
                        popoverOffsetX={-258}
                    >
                        {({isOpen}) => (
                            <div className={'d-flex align-items-center justify-content-center'}>
                                {isOpen ? <TemplateIcon color={'#fff'} /> : <TemplateIcon />}
                            </div>
                        )}
                    </PopoverIcon>
                    <PopoverIcon
                        color={'default'}
                        className={'Icon shadow-1'}
                        ContentComponent={ShortcutHelper}
                        placement={'top'}
                        trigger={'click'}
                        popoverOffsetX={-90}
                    >
                        {({isOpen}) => (
                            <div className={'d-flex align-items-center justify-content-center'}>
                                {isOpen ? <KeyboardIcon color={'#fff'} /> : <KeyboardIcon />}
                            </div>
                        )}
                    </PopoverIcon>
                </div>
            )}
        </div>
    )
}

export default SwitchBetweenSidesWithHelper
